import { render, staticRenderFns } from "./SimpleAlert.vue?vue&type=template&id=ba4c8a00&"
import script from "./SimpleAlert.vue?vue&type=script&lang=ts&"
export * from "./SimpleAlert.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports